module.exports = __webpack_public_path__ + "img/关于我们.cebaa0f3.jpg";